export class CompanyFinancialReports {
  private companyFinancialReportKey: string;
  private fiscalNumber: string;
  private cycleBalanceStartDate: string;
  private cycleBalanceEndDate: string;
  private operationDate: string;
  private companyName: string;
  private employeeCount: number;
  public downloadUrl: string;

  public getCompanyName(): string {
    return this.companyName;
  }

  public setCompanyName(value: string) {
    this.companyName = value;
  }

  public getCompanyFinancialReportKey(): string {
    return this.companyFinancialReportKey;
  }

  public getFiscalNumber(): string {
    return this.fiscalNumber;
  }

  public getCycleBalanceStartDate(): string {
    return this.cycleBalanceStartDate;
  }

  public getCycleBalanceEndDate(): string {
    return this.cycleBalanceEndDate;
  }

  public getOperationDate(): string {
    return this.operationDate;
  }

  public getEmployeeCount(): number {
    return this.employeeCount;
  }

  public getDownloadUrl(): string {
    return this.downloadUrl;
  }

  public setCompanyFinancialReportKey(value: string) {
    this.companyFinancialReportKey = value;
  }

  public setFiscalNumber(value: string) {
    this.fiscalNumber = value;
  }

  public setCycleBalanceStartDate(value: string) {
    this.cycleBalanceStartDate = value;
  }

  public setCycleBalanceEndDate(value: string) {
    this.cycleBalanceEndDate = value;
  }

  public setOperationDate(value: string) {
    this.operationDate = value;
  }

  public setEmployeeCount(value: number) {
    this.employeeCount = value;
  }

  public setDownloadUrl(value: string) {
    this.downloadUrl = value;
  }

  public getSellingCycle(): string {
    const options = { year: 'numeric' as const, month: 'numeric' as const, day: 'numeric' as const };
    const startDate = new Date(this.cycleBalanceStartDate).toLocaleString("pt-BR", options);
    const endDate = new Date(this.cycleBalanceEndDate).toLocaleString("pt-BR", options);

    const sellingCycle = `(${startDate} a ${endDate})`;
    return sellingCycle;
  }
}
